export const SETTINGS_USER = {
	name: 'Jane Doe',
	email: 'jane.doe@school.edu',
	school: 'Kandor International School',
	reportsTo: 'Head of Counselling',
	avatarKey: 'owl',
}

export const ASSIGNED_STUDENTS_COUNT = 45

export const STUDENTS_PREVIEW_LIMIT = 5

export const STUDENTS = [
	{
		id: 1,
		name: 'Aarav Mehta',
		grade: '12',
		applications: 4,
		assignments: 7,
		avatarKey: 'parrot',
	},
	{
		id: 2,
		name: 'Sara Al Mansoori',
		grade: '12',
		applications: 6,
		assignments: 4,
		avatarKey: 'red_panda',
	},
	{
		id: 3,
		name: 'Maya Patel',
		grade: '11',
		applications: 2,
		assignments: 8,
		avatarKey: 'turtle',
	},
	{
		id: 4,
		name: 'Leila Nasser',
		grade: '12',
		applications: 5,
		assignments: 3,
		avatarKey: 'whale',
	},
	{
		id: 5,
		name: 'Rohan Kapoor',
		grade: '10',
		applications: 1,
		assignments: 6,
		avatarKey: 'bear',
	},
	{
		id: 6,
		name: 'Zoya Shah',
		grade: '11',
		applications: 3,
		assignments: 5,
		avatarKey: 'fox',
	},
	{
		id: 7,
		name: 'Omar Al Harbi',
		grade: '12',
		applications: 5,
		assignments: 2,
		avatarKey: 'dolphin',
	},
	{
		id: 8,
		name: 'Noura Saleh',
		grade: '10',
		applications: 1,
		assignments: 9,
		avatarKey: 'giraffe',
	},
	{
		id: 9,
		name: 'Yousef Haddad',
		grade: '11',
		applications: 2,
		assignments: 6,
		avatarKey: 'wolf',
	},
	{
		id: 10,
		name: 'Leen Saleh',
		grade: '12',
		applications: 4,
		assignments: 4,
		avatarKey: 'koala',
	},
]

export const ACTIVITY_ROWS = [
	{
		id: 'sessions',
		label: 'Completed sessions',
		value: 85,
		tone: 'purple',
	},
	{
		id: 'application-assignments',
		label: 'Application assignments',
		value: 38,
		tone: 'green',
	},
]

export const COVERAGE_SEGMENTS = [
	{ label: 'Supported this cycle', value: 42, tone: 'green' },
	{ label: 'No recent activity', value: 3, tone: 'orange' },
]

export { DEFAULT_NOTIFICATION_PREFERENCES as DEFAULT_NOTIFICATIONS } from '../../../shared/config/typeNotifications'

export const LANGUAGE_OPTIONS = [
	{ name: 'English', code: 'EN', status: 'Current' },
	{ name: 'Arabic', code: 'العربية', status: 'Planned' },
	{ name: 'Japanese', code: '日本語', status: 'Planned' },
	{ name: 'Vietnamese', code: 'VI', status: 'Planned' },
]

export const SUPPORT_ROUTES = [
	{
		id: 'feedback',
		href: 'mailto:yash@trykandor.com?subject=%5BFeedback%5D%20Kandor%20feedback&body=Please%20share%20your%20feedback%20here.',
		iconKey: 'forum',
		tone: 'purple',
		title: 'Feedback',
		description: 'Tell us how your experience with Kandor could be better.',
		email: 'yash@trykandor.com',
	},
	{
		id: 'reporting',
		href: 'mailto:yash@trykandor.com?subject=%5BReporting%20Requirements%5D%20Kandor%20reporting%20request&body=Please%20describe%20the%20reporting%20requirement.',
		iconKey: 'analytics',
		tone: 'blue',
		title: 'Reporting requirements',
		description: 'Request a report, export or change to the information you need.',
		email: 'yash@trykandor.com',
	},
	{
		id: 'feature',
		href: 'mailto:yash@trykandor.com?subject=%5BFeature%20Idea%5D%20Kandor%20feature%20request&body=Please%20describe%20the%20feature%20idea%20and%20the%20problem%20it%20would%20solve.',
		iconKey: 'lightbulb',
		tone: 'orange',
		title: 'Feature ideas',
		description: 'Share an idea that would improve how your team works in Kandor.',
		email: 'yash@trykandor.com',
	},
	{
		id: 'issue',
		href: 'mailto:navdeep@trykandor.com?subject=%5BSomething%20is%20Wrong%5D%20Kandor%20issue&body=Please%20tell%20us%20what%20happened%2C%20what%20you%20expected%20and%20which%20student%20or%20page%20was%20affected.',
		iconKey: 'bug',
		tone: 'green',
		title: 'Something is wrong',
		description: 'Let us know if something is broken, missing or behaving unexpectedly.',
		email: 'navdeep@trykandor.com',
		urgent: true,
	},
]

export const CEO_CONTACT = {
	name: 'Navdeep Singh',
	role: 'CEO',
	email: 'navdeep@trykandor.com',
	whatsapp: '+1 732 781 6325',
	whatsappHref: 'https://wa.me/17327816325',
}

export const MAIN_SECTIONS = [
	{
		id: 'communication',
		title: 'Communication',
		rows: [
			{
				id: 'parent-communication',
				iconKey: 'family',
				title: 'Parent communication',
				subtitle: 'Configure parent email updates and manage parent contacts',
				meta: 'Updates & contacts',
				tone: 'green',
				view: null,
				action: 'parentCommunication',
			},
		],
	},
	{
		id: 'school',
		title: 'School',
		rows: [
			{
				id: 'school-preferences',
				iconKey: 'calendar',
				title: 'School preferences',
				subtitle: 'Manage the academic year start and end dates',
				metaKey: 'academicYearLabel',
				tone: 'blue',
				view: 'school-preferences',
				adminOnly: true,
			},
		],
	},
	{
		id: 'notifications',
		title: 'Notifications',
		rows: [
			{
				id: 'counsellor-notifications',
				iconKey: 'bell',
				title: 'Counsellor notifications',
				subtitle: 'Choose the student updates you want to see',
				metaKey: 'activeNotifications',
				tone: 'purple',
				view: 'notifications',
			},
		],
	},
	{
		id: 'support',
		title: 'Support',
		rows: [
			{
				id: 'help-centre',
				iconKey: 'help',
				title: 'Help centre',
				subtitle: 'Get support or share product feedback',
				tone: 'purple',
				view: 'support',
			},
		],
	},
]
